import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {DmDashboardComponent} from "../component/protected-components/dm-dashboard/dm-dashboard.component";
import {DmDocumentComponent} from "../component/protected-components/dm-document/dm-document.component";
import {
    DmDocumentProcessingComponent
} from "../component/protected-components/dm-document-processing/dm-document-processing.component";
import {
    DmDocumentUploadComponent
} from "../component/protected-components/dm-document-upload/dm-document-upload.component";
import {
    DocumentProcessActionsComponent
} from "../component/protected-components/document-process-actions/document-process-actions.component";
import {ObjectDocumentComponent} from "../component/protected-components/object-documents/object-documents.component";
import {
    DmDocumentUploadWfProcessStepActivityComponent
} from "../component/protected-components/wf/dm-document-upload-wf-process-step-activity/dm-document-upload-wf-process-step-activity.component";
import {
    ObjectDocumentConsultantComponent
} from "../component/protected-components/consultant-component/object-documents/object-documents-consultant.component";

const dmModuleEntry: TestModuleDefinition = {
    key: 'dm',
    label: 'Document (dm)',
    components: [
        {
            key: 'DmDashboardComponent',
            component: DmDashboardComponent,
            selector: 'mvs-dm-dashboard-page',
            type: 'ObjectComponent',
            label: 'Dm Dashboard'
        },
        {
            key: 'DmDocumentComponent',
            component: DmDocumentComponent,
            selector: 'mvs-dm-document-component',
            type: 'ObjectBaseComponent',
            label: 'Document Component'
        },
        {
            key: 'DmDocumentProcessingComponent',
            component: DmDocumentProcessingComponent,
            selector: 'mvs-dm-processing',
            type: 'Component',
            label: 'Document Processing'
        },
        {
            key: 'DmDocumentUploadComponent',
            component: DmDocumentUploadComponent,
            selector: 'mvs-dm-document-upload',
            type: 'Component',
            label: 'Document Upload'
        },
        {
            key: 'DocumentProcessActionsComponent',
            component: DocumentProcessActionsComponent,
            selector: 'document-process-actions',
            type: 'Component',
            label: 'Document Process Actions'
        },
        {
            key: 'ObjectDocumentComponent',
            component: ObjectDocumentComponent,
            selector: 'mvs-dm-object-documents',
            type: 'Component',
            label: 'Object Document Component'
        },
        {
            key: 'DmDocumentUploadWfProcessStepActivityComponent',
            component: DmDocumentUploadWfProcessStepActivityComponent,
            selector: 'mvs-wf-process-step-activity-document-object',
            type: 'Component',
            label: 'DM Document Upload Wf Process Step Activity'
        },
        {
            key: 'ObjectDocumentConsultantComponent',
            component: ObjectDocumentConsultantComponent,
            selector: 'mvs-dm-object-documents-consultant',
            type: 'ObjectDocumentComponent',
            label: 'object document consultant component'
        },
    ]
};

export const DM_TEST_PROVIDERS: Provider[] = [
    { provide: TEST_MODULE_REGISTRY, useValue: dmModuleEntry, multi: true }
];